export default (context, inject) => {
  const constants = {
    JOBS_RESULTS_PER_PAGE: 10
  };

  inject("constants", constants);
  context.$constants = constants;
};
